import { BACKEND_BASE_URL } from "./backendBaseUrl";
export const LOGS_BASE_URL = BACKEND_BASE_URL + "/logs";
